"use client";

import { useFetchApi } from "@/composables/useFetchApi";
import type { StrapiCollectionResponse, StrapiQuery, StrapiQueryValue } from "@/lib/strapi";
import type { ProductAttributes } from "@/services/product";

export type UseProductsOptions = {
  enabled?: boolean;
  query?: StrapiQuery;
  populate?: StrapiQueryValue;
  pageSize?: number;
  withBrandFilter?: boolean;
  initialData?: StrapiCollectionResponse<ProductAttributes> | null;
};

export function useProducts(options?: UseProductsOptions) {
  const query: StrapiQuery = {
    ...(options?.query ?? {}),
    filters: {
      ...(typeof options?.query?.filters === "object" && options?.query?.filters !== null
        ? (options.query.filters as Record<string, unknown>)
        : {}),
      show_in_products: { $eq: true },
      active: { $eq: true },
    },
    sort: options?.query?.sort ?? ["updatedAt:desc"],
    pagination: {
      ...(typeof options?.query?.pagination === "object" && options?.query?.pagination !== null
        ? (options.query.pagination as Record<string, unknown>)
        : {}),
      pageSize: options?.pageSize ?? 12,
    },
    populate:
      options?.populate !== undefined
        ? options.populate
        : (options?.query?.populate ?? {
            cover_image: { populate: "*" },
            product_category: { populate: "*" },
            product_collection: { populate: "*" },
            ecommerce_links: { populate: "*" },
          }),
  };

  const state = useFetchApi<StrapiCollectionResponse<ProductAttributes>>("/products", {
    enabled: options?.enabled,
    query,
    withBrandFilter: options?.withBrandFilter,
    initialData: options?.initialData,
    cacheTtlMs: 3600_000,
  });

  const products = state.data?.data ?? [];

  return { ...state, products };
}
